exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".actions[data-v-71c0e238] {\n  width: 6%;\n}\n.asset-type-filter[data-v-71c0e238] {\n  width: 10%;\n  float: right;\n}\n.custom-paginated-table .action-buttons[data-v-71c0e238] {\n  width: 100px;\n}\n.card-icon[data-v-71c0e238] {\n  background: #0976b4 !important;\n}\n.note-image[data-v-71c0e238] {\n  max-height: 50px;\n  width: initial;\n  background-color: #eee;\n}\n", ""]);

// exports
